import React from "react";
import "../../styles/glass.css"
import "../../styles/globals.css";
import "../../styles/layout.css";
import "../styles/platform.css"
import "../styles/LeftSidebar.css"
import HeaderPlatform from "../components/HeaderPlatform";
import FooterPlatform from "../components/FooterPlatform";
import LeftSidebar from "../components/LeftSidebar";
import GlassCard from "../../components/GlassCard";
import { useCurrentLang } from "../../hooks/useCurrentLang";
import { ExerciseBlock } from "../components/ExerciseBlock";
import { useState } from 'react';
import BasicInfoBox from "../components/BasicInfoBox";
import { exeNotiText } from "../data/platformText";
export const MyExercisesPage = () => {
    const currentLang = useCurrentLang();
    const t = exeNotiText[currentLang];
    const [exercises] = useState([
        
            // non‑session example
            {
              id: 'ex-1',
              name: 'Plank Hold',
              difficulty: 'easy',
              inSession: false, // <- non-session layout
              muscles: ['Core', 'Shoulders', 'Glutes'],
              longDescription: 'Long description from DB...',
              detailImages: ['/img/plank1.jpg', '/img/plank2.jpg'],
              detailMusclesImageUrl: '/img/muscles_core.png',
              detailYoutubeUrl: 'https://www.youtube.com/watch?v=pSHjTRCQxIw',
              commonMistakes: [
                'Hips sagging toward the floor.',
                'Neck looking forward instead of down.',
              ],
            },
            {
              id: 'ex-2',
              name: 'Plank Hold',
              difficulty: 'easy',
              inSession: false, // <- non-session layout
              muscles: ['Core', 'Shoulders', 'Glutes'],
              longDescription: 'Long description from DB...',
              detailImages: ['/img/plank1.jpg', '/img/plank2.jpg'],
              detailMusclesImageUrl: '/img/muscles_core.png',
              detailYoutubeUrl: 'https://www.youtube.com/watch?v=pSHjTRCQxIw',
              commonMistakes: [
                'Hips sagging toward the floor.',
                'Neck looking forward instead of down.',
              ],
            },
          ]);
        const [expandedId, setExpandedId] = useState(null);
              
        const handleToggleExpand = (id) => {
            setExpandedId((prev) => (prev === id ? null : id)); // only one open
        };
        
        const handleCompleteExercise = (id) => {
            console.log('Exercise completed:', id);
            // here you can call API, update state, etc.
        };
    return(
        <div className='revimo-layout'>
            <HeaderPlatform/>
            <main className="revimo-main">
            <LeftSidebar/>
            <div className="revimo-page-content">
                <GlassCard style={{padding: "10px", maxWidth:"775px", marginLeft: "50px"}}>
                <div className="profile-section header-section">
                <div className="profile-col profile-col-left">
                    <div className="profile-main-name" style={{paddingTop: "10px"}}>{t.t_exe}</div>
                    <div style={{textAlign: "start"}}><div className="profile-main-username"></div>
                    <div className="profile-main-sex"></div></div>
                </div>
                </div>
                </GlassCard>
                <GlassCard style={{padding: "20px", maxWidth:"775px", marginLeft: "50px", marginTop: "25px"}}>
                  <div style={{fontSize: "0.8rem",textTransform: "uppercase",letterSpacing: "0.08em",opacity: 0.7, }}>{t.s_exe}</div>
                {exercises.map((ex) => (<ExerciseBlock key={ex.id} {...ex} option="onPlatform" isExpanded={expandedId === ex.id} onToggleExpand={handleToggleExpand} onCompleteExercise={handleCompleteExercise} l_m={"0px"}/>))}
                </GlassCard>
            </div>
            </main>
            <footer className="revimo-footer">
            <FooterPlatform/>
            </footer>
        </div>
    );
};
export default MyExercisesPage;